import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./App.css";
import Navbar from "./NavBar";
import { refreshAccessToken, logout, AuthControl } from "./auth";

function YonetimIzinGiris() {
  const [personnelList, setPersonnelList] = useState([]);
  const [selectedSicil, setSelectedSicil] = useState("");
  const [leaveReport, setLeaveReport] = useState([]);
  const [loadingLeaveReport, setLoadingLeaveReport] = useState([]);

  const[pendingLeaves,setPendingLeaves]= useState([]);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [loading_personnel, setLoading] = useState(true);
  const [user, setuser]=useState(null);
const [loading, set_Loading]=useState(true);
const [leaveBreakdown, setLeaveBreakdown] = useState([]);
const [kunye, setKunye] = useState([]);
const [loadingKunye, set_LoadingKunye]=useState(true);
const [formData, setFormData] = useState({
    SICIL_NO: '',
    IZIN_TUR: '',
    BASLANGIC_TARIH: '',
    BITIS_TARIH: '',
    ACIKLAMA:'',
    YARIM1: false,
    YARIM2: false,
    BORC: false
  });
  const [izinTurleri, setIzinTurleri] = useState([
      { ID: 1, name: "Doğum İzni" },
      { ID: 2, name: "Mazeret İzni"},
      { ID: 3, name: "Evlilik İzni"},
      { ID: 4, name: "Cenaze İzni"},
      { ID: 5, name: "Yıllık İzin"},
      { ID: 6, name: "İş Kazası"},
      { ID: 7, name: "Mazeretsiz"},
      { ID: 9, name: "Rapor" },
      { ID: 10, name: "Ücretsiz İzin" },
      { ID: 11, name: "Ücretli İzin" },
      { ID: 12, name: "Seyahat Raporu" },
      { ID: 13, name: "Süt İzni" },
      { ID: 14, name: "Görevli" },
      { ID: 15, name: "Babalık İzni" },
      { ID: 16, name: "Doğumgünü İzni" },
      { ID: 17, name: "Taşınma İzni" },
      { ID: 18, name: "Esnek Çalışma İzni" },
      { ID: 19, name: "Öğle Arası İzni" },
      { ID: 20, name: "Eğitim İzni" },
      { ID: 21, name: "Askerlik İzni" },
      { ID: 22, name: "Refakat İzni" },
      { ID: 23, name: "Uzaktan Çalışma İzni" }
    ]);


    const countValidDays = (startDate, endDate, yarim1, yarim2) => {
      let count = 0;
      const date1 = new Date(startDate);
      date1.setHours(0,0,0,0);
      const date2 = new Date(endDate);
      date2.setHours(0,0,0,0);
      while (date1 <= date2) {
        const day = date1.getDay(); // 0 = Sunday
        if (day !== 0) count++;
        date1.setDate(date1.getDate() + 1);
      }
      if(yarim1) count = count - 0.5;
      if(yarim2) count = count - 0.5;
      console.log("countvaliddays:",count);
      return count;
    };
  const validateIzinForm = (formData) => {
    const izinTurID = parseInt(formData.IZIN_TUR);
    const start = new Date(formData.BASLANGIC_TARIH);
    const end = new Date(formData.BITIS_TARIH);
    const yarim1 = formData.YARIM1;
    const yarim2 = formData.YARIM2;
    const borc = formData.BORC;
    if (isNaN(izinTurID) || !formData.BASLANGIC_TARIH || !formData.BITIS_TARIH) {
      return { valid: false, message: "Lütfen izin türünü ve tarihleri seçin." };
    }
  
    if (end < start) {
      return { valid: false, message: "Bitiş tarihi başlangıç tarihinden önce olamaz." };
    }
  if (formData.YARIM1 && formData.YARIM2 && start.getTime()===end.getTime()) {
      return { valid: false, message: "Tek günlük izinlerde hem başlangıç hem bitiş yarım gün olamaz." };
    }
    // Count days excluding Sundays (and optionally Saturdays for specific cases)
    
  const gun = countValidDays(start, end, yarim1,yarim2);
    // --- İzin kuralları ---
    if(borc) return { valid: true }; // sorun yok
    if(gun<=0)
      return { valid: false, message: "İzin aralığı geçersiz. Kontrol ediniz." };
    if (izinTurID === 1) { // Doğum İzni
      
      if (gun > 96) {//Pazarlar sayılmıyor (16 hafta * 6)
        return { valid: false, message: "Doğum izni en fazla 16 hafta olabilir." };
      }
    }
    
    if (izinTurID === 3) { // Evlilik İzni
      
      if (gun > 3) {
        return { valid: false, message: "Evlilik izni en fazla 3 gün olabilir." };
      }
    }
    if (izinTurID === 4) { // Cenaze İzni
     
      if (gun > 3) {
        return { valid: false, message: "Cenaze izni en fazla 3 gün olabilir." };
      }
    }
    if (izinTurID === 15) { // Babalık İzni
      
      if (gun > 5) {
        return { valid: false, message: "Babalık izni en fazla 5 gün olabilir." };
      }
    }
    if (izinTurID === 16) { // Doğum günü İzni
      
      if (gun > 1) {
        return { valid: false, message: "Doğum günü izni en fazla 1 gün olabilir." };
      }
    }
    if (izinTurID === 17) { // Taşınma İzni
      
      if (gun > 1) {
        return { valid: false, message: "Taşınma izni en fazla 1 gün olabilir." };
      }
    }
    // Kurallar bitti...
  console.log("Count valid days:",gun);
    return { valid: true }; // sorun yok
  };

  const fetchLeaveBreakdown = async (sicilNo) => {
    //console.log('fetchLeaveBreakdown', sicilNo);
  try {
    const response = await fetch(`/izin_rapor_detay/${sicilNo}`);
    //console.log("response:",response);
    if (!response.ok) {
      const text = await response.text();
      await AuthControl(response,navigate);
      throw new Error(text || "Detaylı izin raporu alınamadı");
    }
    const data = await response.json();

    // Sıralama
    const sortedData = data.yearlyReport;//.sort((a, b) => b.yil - a.yil);

    setLeaveBreakdown(sortedData);
  } catch (err) {
    console.error("fetchLeaveBreakdown error: ", err.message);
    setError(err.message);
  }
};

  const handleSubmitIzin = async (e) => {

    //console.log("handleSubmitIzin:",selectedSicil);
    e.preventDefault();
    set_Loading(true);
    if(!selectedSicil)
    {
      alert("İşlem yapılacak personeli seçiniz.");
      return;
    }
    //console.log("Submitting with formData:", formData);
    
    const validation = validateIzinForm(formData);
    if (!validation.valid) {
      alert(validation.message);
      set_Loading(false);
      return;
    }
    const selected_izin_data= izinTurleri.find((tur) => tur.ID === Number(formData.IZIN_TUR));
    const IZIN_TUR_AD = selected_izin_data?.name||"-";
  
    setFormData({ ...formData, SICIL_NO: selectedSicil });
    const payload = {...formData, SICIL_NO:selectedSicil,IZIN_TUR_AD};
    const response = await fetch(`/yonetim_izin_talep`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({...payload})
    });

    //console.log('Response status:', response.status);
    if (response.ok) {
      alert('İzin kaydedildi');
      //const user = location.state?.user||JSON.parse(localStorage.getItem("user"));
      //sendLeaveNotification(user.SICIL_NO, user.ADI_SOYADI,formData.IZIN_TUR,formData.BASLANGIC_TARIH,formData.BITIS_TARIH );
    setFormData({
      
      SICIL_NO: selectedSicil,
      IZIN_TUR: '',
      BASLANGIC_TARIH: '',
      BITIS_TARIH: '',
      ACIKLAMA:'',
      YARIM1: false,
      YARIM2: false,
      BORC:false
    });
    fetchLeaveReport(selectedSicil);
      
      fetchPendingLeaves(selectedSicil);

      fetchLeaveBreakdown(selectedSicil);
      set_Loading(false);
    
    } else {
      const errorData = await response.json();
      console.log('Error response:', errorData);  
      alert(`Hata: ${errorData.error || 'Kayıt hatası'}`);
      set_Loading(false);
    }
  };


  useEffect(() => {
      async function init() {
        const success = await refreshAccessToken();
        if (!success) {
          console.log('Refresh failed, redirected to login.');
          return;
        }
    
        try {
          const res = await fetch('/me', { credentials: 'include' });
          const data = await res.json();
          if (res.ok) {
            if (data.sicil_no) {
              //setFormData((prevData) => ({ ...prevData, SICIL_NO: data.SICIL_NO }));
              setuser(data);
              await fetchPersonnel();
            } else {
                      console.error("Sicil bilgisi bulunamadı");
                      alert("Kullanıcı bilgilerinin yeniden girilmesi gerekiyor.");
                    logout();
                    }
                  } else {
                    console.error("User fetch error:", data.error);
                    alert("Kullanıcı bilgilerinin yeniden girilmesi gerekiyor.");
                    logout();
                  }
                } catch (err) {
                  console.error("User fetch exception:", err);
                  alert("Kullanıcı bilgilerinin yeniden girilmesi gerekiyor.");
                  logout();
                }
      }
    
      init();
      
    }, []);
    const fetchPersonnel = async () => {
      try {
        const response = await fetch("/personel_listesi");
        if (!response.ok) {
            const text = await response.text();
            await AuthControl(response,navigate);
            throw new Error(text || "Personel listesi alınamadı");
          }
          const data = await response.json();
        setPersonnelList(data);
        setLoading(false); //personel yükleme tamam
      } catch (err) {
        setError(err.message);
      }
      };
      /*
  useEffect(() => {
    // Fetch personnel list on page load
    const fetchPersonnel = async () => {
      try {
        const response = await fetch("/personel_listesi");
        if (!response.ok) {
            const text = await response.text();
            throw new Error(text || "Personel listesi alınamadı");
          }
          const data = await response.json();
        setPersonnelList(data);
        setLoading(false); //personel yükleme tamam
      } catch (err) {
        setError(err.message);
      }
    };
    fetchPersonnel();
  }, []);*/

  const fetchPendingLeaves = async (sicilNo) => {
    try {
        const response = await fetch(`/bekleyen_izin_personel/${sicilNo}`);
        
        if (!response.ok) {
            const text = await response.text();
            await AuthControl(response,navigate);
            throw new Error(text || "Onaylı izinler alınamadı");
          }
          const data = await response.json();
          setPendingLeaves(data);

    }catch (err) {
        setError(err.message);
      }
  };

  const fetchLeaveReport = async (sicilNo) => {
    //console.log("fetchLeaveReport:", sicilNo);
    setLoadingLeaveReport(true);
    try {
      //console.log("fetchLeaveReport - inside try");
      const response = await fetch(`/izin_rapor/${sicilNo}`);
      if (!response.ok) {
        const text = await response.text();
        await AuthControl(response,navigate);
        throw new Error(text || "İzin kayıtları alınamadı");
      }
      const data = await response.json();
      //console.log("fetchLeaveReport response:",data);
      setLeaveReport(data);
    } catch (err) {
      setError(err.message);
    }finally{setLoadingLeaveReport(false);}
    
  };
const fetchKunye = async (sicilNo) => {
    //console.log("fetchKunye:", sicilNo);
    set_LoadingKunye(true);
    try {

      const response = await fetch(`/kunye/${sicilNo}`);
      if (!response.ok) {
        const text = await response.text();
        await AuthControl(response,navigate);
        throw new Error(text || "İzin kayıtları alınamadı");
      }
      const data = await response.json();
      setKunye(data);
    } catch (err) {
      setError(err.message);
    }finally{set_LoadingKunye(false);}
    
  };
  useEffect(() => {
    if (selectedSicil) {
      fetchKunye(selectedSicil);
      fetchLeaveReport(selectedSicil);
      fetchLeaveBreakdown(selectedSicil);
      fetchPendingLeaves(selectedSicil);
    }
  }, [selectedSicil]);


  const handleDelete = async (id) => {
    
    if(!user)
    {
      alert("Kullanıcı bilgisine ulaşılamıyor. Yeniden giriş yapınız.");
      return;
    }

    const confirm = window.confirm("Bu izni silmek istediğinize emin misiniz?");
    if (!confirm) return;
    setLoading(true);
    try {
      const response = await fetch(`/izin_sil/${id}`, {
        method: "POST",
      });
  
      if (response.ok) {
        window.alert("Kayıt silindi.");
        fetchLeaveReport(selectedSicil);
      
      fetchPendingLeaves(selectedSicil);
      fetchLeaveBreakdown(selectedSicil);
      } else {
        const error = await response.json();
        window.alert(`Hata: ${error.message || "Silme işlemi başarısız."}`);
      }
    } catch (err) {
      console.error("Silme hatası:", err);
      window.alert("Sunucu hatası oluştu.");
    }finally{setLoading(false);}
  };

  return (
    <div>
    
    <div className="container">
      <Navbar />
      <h2>Personel İzin Raporu</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}

      <label>Personel Seçiniz:</label>
      <select
        value={selectedSicil}
        onChange={(e) =>{
            const newSicil=e.target.value;
            //console.log("newSicil",newSicil);
            setSelectedSicil("");
             setSelectedSicil(newSicil);
             setFormData({ ...formData, SICIL_NO: newSicil })
        }}
        disabled={loading_personnel}
      >
        {loading_personnel?(<option value="">Personel Listesi Yükleniyor...</option>):(<><option value="">-- Seçiniz --</option>
        {personnelList.map((person) => (
          <option key={person.SICIL_NO} value={person.SICIL_NO}>
            {person.ADI_SOYADI}
          </option>
        ))}</>
    )}
      </select>
 {selectedSicil && (<table className="report-table">
              <thead>
                <tr>
                  <th>Sicil No</th>
                  <th>Yaş</th>
                  <th>Hizmet Yılı</th>
                  <th>Statü</th>
                </tr>
              </thead>
              <tbody>
               
                  <tr>
                    <td>{selectedSicil}</td>
                   <td>{(kunye.YAS)??"-"}</td>
                    <td>{(kunye.YIL)??"-"}</td>
                    <td>{kunye.STATU??"-"}</td>
                  </tr>
               <tr>
                  <th colSpan="2">Departman</th>
                  <th colSpan="2">İşe Giriş Tarihi</th>
                </tr>
                 <tr>
                  <td colSpan="2">{kunye.DEPARTMAN_ADI}</td>
                  <td colSpan="2">{new Date(kunye.ISE_GIRIS_TARIHI).toLocaleDateString('tr-TR')}</td>
                </tr>
              </tbody>
            </table>
          )}

      {selectedSicil && (
        <>
          <h2>İzin Kullanım Özeti</h2>
          {loadingLeaveReport?(<p>Rapor yükleniyor... Bekleyiniz...</p>):(leaveReport.length > 0 ? (
            <table className="report-table">
              <thead>
                <tr>

                  <th>İzin Türü</th>
                  <th>Kullanılan</th>
                  <th>Kalan Hak</th>
                </tr>
              </thead>
              <tbody>
                {leaveReport.map((item, index) => (
                  <tr key={index}>
                    
                    <td>{item.ACIKLAMA}</td>
                    <td>{(item.TOPLAM_GUN)??"-"}</td>
                    <td style={Number(item.KALAN)<=0?{color:'red',fontWeight:'bold'}:{}}>{item.KALAN??"-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>Kayıtlı izin bulunamadı.</p>
          ))}

<h2>Yıllık İzin Hakediş Detayı</h2>
{leaveBreakdown.length > 0 ? (
  <table className="report-table">
    <thead>
      <tr>
        <th>Dönem</th>
        <th>Devreden</th>
        <th>Cari Yıl İzni</th>
        <th>Kullanılan</th>
        <th>Bakiye</th>
      </tr>
    </thead>
    <tbody>
      {leaveBreakdown.slice().reverse().map((item, index) => (
        <tr key={index}>
          <td>{item.donem}</td>
          <td>{item.devir}</td>
          <td>{item.hakedis}</td>
          <td>{item.used}</td>
          <td>{item.bakiye}</td>
        </tr>
      ))}
    </tbody>
  </table>
) : (
  <p>Hakediş verisi bulunamadı.</p>
)}

{selectedSicil && (
        <>
        <h1>İzin Giriş Formu</h1>
        <form onSubmit={handleSubmitIzin}>
          <label htmlFor="sicil_no">Sicil No</label>
          <input
            id="sicil_no"
            type="text"
            value={formData.SICIL_NO}
            readOnly 
            onChange={(e) => setFormData({ ...formData, SICIL_NO: e.target.value })}
          />
          
          <label htmlFor="izin_tur">İzin Tür</label>
          <select
          id="izin_tur"
          value={formData.IZIN_TUR}
          onChange={(e) => setFormData({ ...formData, IZIN_TUR: e.target.value })}
          >
          <option value="">Seçiniz</option>
          {izinTurleri.map((tur) => (
            <option key={tur.ID} value={tur.ID}>
              {tur.name}
            </option>
          ))}
        </select>
          
          <label htmlFor="baslangic_tarih">Başlangıç Tarihi</label>
          <input
            id="baslangic_tarih"
            type="date"
            value={formData.BASLANGIC_TARIH}
            onChange={(e) => setFormData({ ...formData, BASLANGIC_TARIH: e.target.value })}
          />

           <label style={{display:'inline-flex', marginBottom: '0.8rem', alignItems:'center', gap:'12px', whiteSpace: 'nowrap'}} >Yarım gün
            <input type="checkbox" checked={formData.YARIM1} onChange={(e) => setFormData({ ...formData, YARIM1: e.target.checked })} style ={{transform: 'scale(1)',margin: '0',padding:'0', cursor: 'pointer'}} />
          </label>

          <label htmlFor="bitis_tarih">Bitiş Tarihi</label>
          <input
            id="bitis_tarih"
            type="date"
            value={formData.BITIS_TARIH}
            onChange={(e) => setFormData({ ...formData, BITIS_TARIH: e.target.value })}
          />

           <label style={{display:'inline-flex', marginBottom: '0.8rem', alignItems:'center', gap:'12px', whiteSpace: 'nowrap'}} >Yarım gün
            <input type="checkbox" checked={formData.YARIM2} onChange={(e) => setFormData({ ...formData, YARIM2: e.target.checked })} style ={{transform: 'scale(1)',margin: '0',padding:'0', cursor: 'pointer'}}/>
          </label>

          <label htmlFor="aciklama">Açıklama</label>
          <textarea
            id="aciklama"
            value={formData.ACIKLAMA}
            onChange={(e) => setFormData({ ...formData, ACIKLAMA: e.target.value })}
            rows="4"
            placeholder=""
          ></textarea>
          <label style={{display:'inline-flex', marginBottom: '0.8rem', alignItems:'center', gap:'12px', whiteSpace: 'nowrap'}} >Borçlandır
            <input type="checkbox" checked={formData.BORC} onChange={(e) => setFormData({ ...formData, BORC: e.target.checked })} style ={{transform: 'scale(1)',margin: '0',padding:'0', cursor: 'pointer'}}/>
          </label>
          <button  type="submit">Gönder</button>
        </form>
        </>
)}


          {pendingLeaves.length > 0 ?(<>
            <h2>İzin Talepleri</h2>
            <div className="table_wrapper">
            <table>
              <thead>
                <tr>
                  
                  <th>İzin Türü</th>
                  <th>Başlangıç</th>
                  <th>Bitiş</th>
                  <th>Talep Edilen Gün</th>
                  <th>Açıklama/Gerekçe</th>
                  <th>Kayıt Tarihi</th>
                  <th>Onay</th>
                  <th>Sil</th>
                </tr>
              </thead>
              <tbody>
                {pendingLeaves.map((izin) => (
                  <tr key={izin.ID}>
                    
                    <td>{izin.IZIN_TUR_AD}</td>
                    <td>{new Date(izin.BASLANGIC_TARIH).toLocaleString('tr-TR')}</td>
                    <td>{new Date(izin.BITIS_TARIH).toLocaleString('tr-TR')}</td>
                    <td>{izin.TALEP_GUN}</td>
                    <td>{izin.ACIKLAMA}</td>
                    <td>{new Date(izin.KAYIT_TARIHI).toLocaleString('tr-TR')}</td>
                     <td>{izin.ONAY === true ? '✔️' : izin.ONAY === false ? '❌' : '⏳'}</td>
                    <td>
                      <td>{(<button onClick={() => handleDelete(izin.ID)}>🗑️</button>)}</td>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table></div></>):(
            <p>Onay bekleyen izin kaydı bulunamadı.</p>
          )
          }
        </>
      )}
    </div>
    </div>
  );
}

export default YonetimIzinGiris;